<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :title="$t('mentora_course_approval_review')"
                @filter-div-status="datatable.filterStatus = $event">
        </Header>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :title="$t('mentora_course_approval_review')"
                      @filter-div-status="datatable.filterStatus = $event">
        </HeaderMobile>
      </template>
      <datatable-filter v-show="datatable.filterStatus" @filter="$refs.datatable.getRows()"
                        @filterClear="$refs.datatable.filterClear()"
                        :exportExcel="true" @exportExcel="$refs.datatable.excel()">
        <b-row>
          <b-col xs="12" sm="6" md="4" lg="3" xl="2">
            <b-form-group :label="$t('student_number')">
              <b-form-input v-model="datatable.queryParams.filter.student_number">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="6" md="4" lg="3" xl="2">
            <b-form-group :label="$t('first_name')">
              <b-form-input v-model="datatable.queryParams.filter.name">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="6" md="4" lg="3" xl="2">
            <b-form-group :label="$t('surname')">
              <b-form-input v-model="datatable.queryParams.filter.surname">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="6" md="4" lg="4">
            <b-form-group :label="$t('approval_status')">
              <multi-selectbox
                  v-model="datatable.queryParams.filter.active_session_approval_status"
                  :options="[
                                    {
                                        value: 'Not Assigned',
                                        text: 'Not Assigned'
                                    },
                                    {
                                        value: 'Not Enrolled',
                                        text: 'Not Enrolled'
                                    },
                                    {
                                        value: 'Pending Payment',
                                        text: 'Pending Payment'
                                    },
                                    {
                                        value: 'Pending Registration',
                                        text: 'Pending Registration'
                                    },
                                    {
                                        value: 'Registration Completed',
                                        text: 'Registration Completed'
                                    },
                                    {
                                        value: 'Exempt',
                                        text: 'Exempt'
                                    }
                                    ]"
                  :multiple="false"
              ></multi-selectbox>
            </b-form-group>
          </b-col>
        </b-row>
      </datatable-filter>

      <datatable ref="datatable" :isLoading="datatable.isLoading"
                 :columns="datatable.columns"
                 :rows="datatable.rows"
                 :total="datatable.total"
                 :queryParams="datatable.queryParams"
                 v-show="datatable.showTable"
                 :data-function="callService"
      >
      </datatable>
    </app-layout>
  </div>
</template>
<script>
//Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import qs from "qs";
import MentoraCourseApprovalReviewService from "@/services/MentoraCourseApprovalReviewService";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import PaymentPlanService from "@/services/PaymentPlanService";

export default {
  components: {
    MultiSelectbox,
    AppLayout,
    Header,
    HeaderMobile,
    DatatableFilter,
    Datatable,
  },
  metaInfo() {
    return {
      title: this.$t("mentora_course_approval_review"),
    };
  },
  data() {
    return {
      formId: 0,
      form: {},
      formProcess: null,
      datatable: {
        isLoading: false,
        columns: [
          {
            label: this.$t("student_number"),
            field: "student_number",
            sortable: true,
          },

          {
            label: this.$t("first_name"),
            field: "name",
            sortable: false,
          },
          {
            label: this.$t("last_name"),
            field: "surname",
            sortable: false,
          },
          {
            label: this.$t("email"),
            field: "email",
            sortable: false,
            hidden: true,
          },
          {
            label: this.$t("personal_email"),
            field: "personal_email",
            sortable: false,
            hidden: true,
          },
          {
            label: this.$t("phone_number"),
            field: "mobile_tel",
            sortable: false,
            hidden: true,
          },
          {
            label: this.$t("module_status"),
            field: "module_status",
            sortable: false,
          },
          {
            label: this.$t("course"),
            field: "course_name",
            sortable: false,
          },
          {
            label: this.$t("approval_status"),
            field: "approval_status",
            sortable: false,
            formatFn: (value) => {
              let variant = 'badge-info';
              if(!value) return '';
              if (value.includes('Not Assigned')) variant = 'badge-dark';
              else if (value.includes('Not Enrolled')) variant = 'badge-danger';
              else if (value.includes('Pending Payment')) variant = 'badge-danger';
              else if (value.includes('Pending Registration')) variant = 'badge-warning';
              else if (value.includes('Registration Completed')) variant = 'badge-success';
              return `<span class="badge ${variant}">${value}</span>`;
            }
          },
          {
            label: this.$t("payment_status"),
            field: "payment_status",
            sortable: false,
            formatFn: (value) => {
              let variant = null;
              if (value==='No') variant = 'badge-danger';
              else if (value==='Yes') variant = 'badge-success';
              return `<span class="badge ${variant}">${value}</span>`;
            }
          },
        ],
        rows: [],
        total: 0,
        filterStatus: true,
        showTable: false,
        queryParams: {
          filter: {},
          sort: "id",
          page: 1,
          limit: 20,
        },
      },
    };
  },
  methods: {
    callService(config) {
      let response = MentoraCourseApprovalReviewService.getAll(config)
      return response;
    },

  },
};
</script>

